export const roundToNextFifteenMinutes = (date: Date) => {
    const roundedDate = new Date(date);
    const minutes = roundedDate.getMinutes();
    const remainder = minutes % 15;
                                    
    if (remainder !== 0) {
    roundedDate.setMinutes(minutes + (15 - remainder));
    }
    roundedDate.setSeconds(0);
    roundedDate.setMilliseconds(0);
                                    
    return roundedDate;
};